@if (product$ | async; as product) { @if (nonDefaultCategories(product.superCategories)) { @if (variantsKeys.length > 0)
{
<div id="prod-variant-section" class="variant-section">
  <!-- <cx-variant-color-selector
        *ngIf="variants[variantType.COLOR]"
        [product]="product"
        [variants]="variants[variantType.COLOR]"
      ></cx-variant-color-selector> -->
  @for (key of variantsKeys; track key; let i = $index) {
  <div>
    @if (!singleOption) { @if (variants[key]) {
    <app-variant-size-selector
      [product]="product"
      [title]="key"
      [isDesktop]="this.isDesktop"
      [variants]="variants[key]"
      [selectedVariantIndex]="selectedVariantIndex"
      [firstSelector]="i == 0"
      (parentUpdate)="update()"
      (isLoading)="isLoading()"
      (parentReload)="reload($event)"
    ></app-variant-size-selector>
    } }
  </div>
  } @if (loading) {
  <div class="rotating"></div>
  }
</div>
} } }
